module.exports = __webpack_public_path__ + "assets/img/sidebar-carrello-icon1.ec99aaf0.svg";